import { Controller } from "@hotwired/stimulus"

const BUTTON_CLASS_BY_DECISION = {
  approve: "btn btn-solid theme-success",
  reject: "btn btn-solid theme-danger",
  suspend: "btn btn-solid theme-danger"
}

const LABEL_BY_DECISION = {
  approve: "Approve",
  reject: "Reject",
  suspend: "Suspend"
}

export default class extends Controller {
  static targets = [ "dialog", "decision", "message", "submitButton" ]
  static values = {
    initialDecision: String,
    openOnConnect: Boolean
  }

  connect() {
    this.dialog = new bootstrap.Dialog(this.dialogTarget)

    if (this.openOnConnectValue && this.hasInitialDecisionValue && this.initialDecisionValue.length > 0) {
      this.openDecision(this.initialDecisionValue)
    }
  }

  open(event) {
    event.preventDefault()

    const button = event.currentTarget
    const decision = button.dataset.reviewActionDecision
    if (!decision) return

    this.openDecision(decision, button.textContent.trim())
  }

  openDecision(decision, submitLabel = null) {
    this.decisionTarget.value = decision
    this.messageTarget.required = decision === "reject"
    this.submitButtonTarget.className = BUTTON_CLASS_BY_DECISION[decision] || "btn btn-solid theme-primary"
    this.submitButtonTarget.textContent = submitLabel || LABEL_BY_DECISION[decision] || "Save Review"

    this.dialog.show()
    this.dialogTarget.addEventListener("shown.bs.dialog", () => {
      this.messageTarget.focus()
    }, { once: true })
  }

  clearDecision() {
    this.decisionTarget.value = ""
    this.messageTarget.required = false
    this.submitButtonTarget.className = "btn btn-solid theme-primary"
    this.submitButtonTarget.textContent = "Save Review"
  }
}
